import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type Preauth, preauth } from "../schemas/preauth";

export const preauthAccountProps = z
  .object({ locale: z.string(), token: z.string() })
  .extend(requestConfig.shape);

export type PreauthAccountProps = z.infer<typeof preauthAccountProps>;

export const preauthAccount = async (
  args: PreauthAccountProps,
): Promise<Preauth> => {
  const {
    brand,
    endpoint = env.ACCOUNT_SERVICE_URL,
    locale,
    token,
    proxyAuthSecret,
  } = parseServiceInput(preauthAccountProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret ? { "X-NG-Proxy-Auth": proxyAuthSecret } : {}),
  });

  const response = await fetch(`${endpoint}/v3/auth/preauth`, {
    method: "POST",
    headers,
    body: JSON.stringify({ locale, brand }),
  });

  return parseServiceOutput(response, preauth, {
    code: "MALFORMED_PREAUTH",
    message: "Preauth is malformed",
  });
};
